// types
import { PriceDataType, PriceListType } from 'types';

// assets
import airOneImage from 'assets/images/device/AIR-1.png';
import l13Image from 'assets/images/device/L13.png';
import x12Image from 'assets/images/device/X12.png';
// import convenienceIcon from 'assets/images/icons/convenience.png';
import deliveryIcon from 'assets/images/icons/delivery.png';
import logo from 'assets/images/wifi-tokyo-logo.png';

export const APP_DEFAULT_PATH = 'mypage';
export const CLOUD_BASE_PATH = process.env.REACT_APP_CLOUD_BASE_PATH || '/cloudwiwi';

export const baseColors: { [key: string]: string } = {
  white: '#ffffff',
  black: '#000000',
  red: '#e60012',
  orange: '#ff9c01',
  green: '#00af50',
  yellow: '#ffff98',
  darkBlue: '#0C3484',
  gray: '#f0f0f0',
  darkGray: '#aaaaaa',
  blackGray: '#444444',
  middleGray: '#aaaaaa',
  lightGray: '#f7f7f7',
  lineGray: '#c3c3c3',
  lightPink: '#fef2f3',
  lightOrange: '#fffaf2',
  bridgeRed: '#ea5755',
  bridgeBlue: '#065d9f',
  bridgeBlack: '#2d2c2c',
  bridgeWhite: '#fcfcfc',
  bridgeDGray: '#333333',
  bridgeLGray: '#6e6f6a',
  bridgeLPink: '#fff3f4',
  cloudOrange: '#ff8503',
  cloudPink: '#ff0072',
  cloudLOrange: '#fff6e7',
  cloudBlack: '#252525',
  cloudGreen: '#00AC9A',
  cloudYellow: '#ffd600',
  cloudBeige: '#faf8e1'
};

export const paymentMethodLabel: { [key: string]: string } = {
  creditCard: 'クレジット決済',
  amazonPay: 'Amazon Pay',
  banking: '銀行振込',
  invoice: '請求書払い',
  shop: '店頭払い',
  rakuten: '楽天',
  yahoo: 'Yahoo!',
  amazon: 'Amazon'
};

export const priceList: PriceListType = {
  cart: {
    limited: [
      {
        id: 1,
        name: '3GB/1日',
        device: ['AIR-1'],
        image: airOneImage,
        gb: 3,
        price: 300,
        tax: true,
        popular: true,
        recommend: false
      },
      {
        id: 2,
        name: '5GB/1日',
        device: ['AIR-1'],
        image: airOneImage,
        gb: 5,
        price: 400,
        tax: true,
        popular: false,
        recommend: false
      },
      {
        id: 3,
        name: '100GB/月',
        device: ['AIR-1'],
        image: airOneImage,
        gb: 100,
        price: 700,
        tax: true,
        popular: false,
        recommend: false
      }
    ],
    unlimited: [
      { id: 4, name: 'ホームルーター', device: ['L13'], image: l13Image, gb: 0, price: 600, tax: true, popular: true, recommend: false },
      { id: 5, name: 'モバイルルーター', device: ['X12'], image: x12Image, gb: 0, price: 600, tax: true, popular: false, recommend: false }
    ]
  },
  extend: {
    limited: [
      {
        id: 6,
        name: '3GB/1日',
        device: ['AIR-1'],
        image: airOneImage,
        gb: 3,
        price: 300,
        tax: true,
        popular: true,
        recommend: false
      },
      {
        id: 7,
        name: '5GB/1日',
        device: ['AIR-1'],
        image: airOneImage,
        gb: 5,
        price: 400,
        tax: true,
        popular: false,
        recommend: false
      },
      {
        id: 8,
        name: '100GB/月',
        device: ['AIR-1'],
        image: airOneImage,
        gb: 10,
        price: 700,
        tax: true,
        popular: false,
        recommend: false
      }
    ],
    unlimited: [
      { id: 9, name: 'ホームルーター', device: ['L13'], image: l13Image, gb: 0, price: 600, tax: true, popular: true, recommend: false },
      { id: 10, name: 'モバイルルーター', device: ['X12'], image: x12Image, gb: 0, price: 600, tax: true, popular: false, recommend: false }
    ]
  }
};

export const securityDeposit = 10000;

export const prefectureList: { label: string }[] = [
  { label: '北海道' },
  { label: '青森県' },
  { label: '岩手県' },
  { label: '宮城県' },
  { label: '秋田県' },
  { label: '山形県' },
  { label: '福島県' },
  { label: '茨城県' },
  { label: '栃木県' },
  { label: '群馬県' },
  { label: '埼玉県' },
  { label: '千葉県' },
  { label: '東京都' },
  { label: '神奈川県' },
  { label: '新潟県' },
  { label: '富山県' },
  { label: '石川県' },
  { label: '福井県' },
  { label: '山梨県' },
  { label: '長野県' },
  { label: '岐阜県' },
  { label: '静岡県' },
  { label: '愛知県' },
  { label: '三重県' },
  { label: '滋賀県' },
  { label: '京都府' },
  { label: '大阪府' },
  { label: '兵庫県' },
  { label: '奈良県' },
  { label: '和歌山県' },
  { label: '鳥取県' },
  { label: '島根県' },
  { label: '岡山県' },
  { label: '広島県' },
  { label: '山口県' },
  { label: '徳島県' },
  { label: '香川県' },
  { label: '愛媛県' },
  { label: '高知県' },
  { label: '福岡県' },
  { label: '佐賀県' },
  { label: '長崎県' },
  { label: '熊本県' },
  { label: '大分県' },
  { label: '宮崎県' },
  { label: '鹿児島県' },
  { label: '沖縄県' }
];

export const genderList: { label: string }[] = [{ label: '男性' }, { label: '女性' }, { label: '未回答' }];

export const deliveryRequestTime: { value: string; label: string }[] = [
  { value: '00', label: '指定しない' },
  { value: '01', label: '午前中' },
  // { value: '12', label: '12:00-14:00' },
  { value: '14', label: '14:00-16:00' },
  { value: '16', label: '16:00-18:00' },
  { value: '18', label: '18:00-20:00' },
  { value: '19', label: '19:00-21:00' }
];

export const shopReceiveTime: { value: string; label: string }[] = [
  { value: '11', label: '11:00-12:00' },
  { value: '12', label: '12:00-13:00' },
  { value: '13', label: '13:00-14:00' },
  { value: '14', label: '14:00-15:00' },
  { value: '15', label: '15:00-16:00' },
  { value: '16', label: '16:00-17:00' },
  { value: '17', label: '17:00-18:00' }
];

export const receiveTypeOptions: { value: string; label: string; image: string }[] = [
  { value: 'delivery', label: '宅急便', image: deliveryIcon },
  // { value: 'convenience', label: 'コンビニ', image: convenienceIcon },
  { value: 'shop', label: '店頭受取', image: logo }
];

export const returnTypeOptions: { value: string; label: string; image: string }[] = [
  { value: 'delivery', label: '宅急便', image: deliveryIcon },
  // { value: 'convenience', label: 'コンビニ', image: convenienceIcon },
  { value: 'shop', label: '店頭返却', image: logo }
];

export const identificationCards: { [key: string]: { label: string; value: string }[] } = {
  invoiceId: [
    { value: 'driver', label: '運転免許証' },
    { value: 'myNumber', label: 'マイナンバーカード' },
    { value: 'passport', label: 'パスポート' },
    { value: 'affiliation', label: '社員証・名刺・会社名が一致する保険証' },
    { value: 'residence', label: '在留カード' }
  ],
  bankingId: [
    { value: 'driver', label: '運転免許証' },
    { value: 'insurance', label: '健康保険証' },
    { value: 'myNumber', label: 'マイナンバーカード' },
    { value: 'passport', label: 'パスポート' },
    { value: 'residence', label: '在留カード' }
  ]
};

export const bankTypeOptions: { label: string; value: string }[] = [
  { label: '普通', value: '0' },
  { label: '当座', value: '1' }
];

export const cloudPriceList: PriceDataType[] = [
  {
    id: 1,
    name: '10GBプラン',
    device: ['U2s'],
    image: airOneImage,
    gb: 10,
    price: 1000,
    tax: true,
    popular: true,
    recommend: false
  },
  {
    id: 2,
    name: '20GBプラン',
    device: ['U2s'],
    image: airOneImage,
    gb: 20,
    price: 1500,
    tax: true,
    popular: false,
    recommend: false
  },
  {
    id: 3,
    name: '50GBプラン',
    device: ['U2s'],
    image: airOneImage,
    gb: 50,
    price: 2500,
    tax: true,
    popular: false,
    recommend: false
  },
  {
    id: 4,
    name: '100GBプラン',
    device: ['U2s'],
    image: airOneImage,
    gb: 100,
    price: 4500,
    tax: true,
    popular: false,
    recommend: false
  }
];

export const cloudInitialFee = 3000; // 初期費用
export const adapterPrice = 1300; // USB ACアダプター価格

export const cloudSafetyPrice: { [key: string]: { label: string; price: number } } = {
  full: { label: '安心保証フル', price: 600 },
  light: { label: '安心保証ライト', price: 300 },
  none: { label: '補償なし', price: 0 }
};
